import React, { FC } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { makeStyles } from '@mui/styles'
import { SelectProps } from '@mui/material'

const useStyles = makeStyles({
  arrow: {
    color: '#FFFFFF',
    opacity: '60%',
  },
})

export const SelectArrow: FC = (props: SelectProps) => {
  const { arrow } = useStyles()

  return <ExpandMoreIcon className={`${arrow} + ${props.className}`} />
}
